import Box from '@mui/material/Box';
import { SystemStyleObject } from '@mui/system/styleFunctionSx/styleFunctionSx';
import React from 'react';

interface Props {
  readonly children: React.ReactNode;
  readonly variant: 'info' | 'warning' | 'error' | 'success';
  readonly leftIcon?: React.ReactElement;
  readonly rightIcon?: React.ReactElement;
  readonly sx?: SystemStyleObject;

  onClick?(): void;
}

export const Alert: React.FC<Props> = (props: Props): React.ReactElement => {
  const { children, variant, onClick, leftIcon, rightIcon, sx } = props;

  const backgroundColor = React.useMemo((): string => {
    switch (variant) {
      case 'info':
        return 'custom.LightBlue';
      case 'warning':
        return 'status.pending.background';
      case 'error':
        return 'status.failed.background';
      case 'success':
        return 'status.completed.background';
    }
  }, [variant]);

  return (
    <Box
      sx={[styles.container, ...(sx ? [sx] : [])]}
      bgcolor={backgroundColor}
      component="button"
      onClick={onClick}>
      {leftIcon}
      <Box flex={1}>{children}</Box>
      {rightIcon}
    </Box>
  );
};

const styles: Record<string, SystemStyleObject> = {
  container: {
    display: 'flex',
    alignItems: 'center',
    borderRadius: 4,
    padding: 3,
    gap: 1.5,
    width: '100%',
    textAlign: 'start',
    border: 'none',
    cursor: 'pointer',
    color: 'text.primary',
  },
  button: {
    padding: 0,
    margin: 0,
    color: 'custom.Primary3Background',
  },
};
